module.exports = __webpack_public_path__ + "static/flaga_ue-664bf43c71afcf59eb0d722d10ce4857.jpg";